module.exports = __webpack_public_path__ + "img/SYNC-alt.56cd7c30.svg";